<div *ngIf="browseType=='productType'">
  <div class="container">
    <div class="row carousel-width">
      <div class="col-12 col-sm-6 col-md-6 text-left">
        <span class="mb-3 h2 ml-3 d-flex align-items-center bold">{{item[0].name}}</span>
      </div>
      <div class="col-11 col-sm-6 col-md-6 text-right visible-xs" *ngIf="item.length>4">
        <a class="btn  mb-3 mr-1 carousel-btn anchor-tag" role="button" (click)="moveLeft()"
          [ngClass]="{'pe-none opacity-25':clickLftBtn==true}">
          <i class="fa fa-lg fa-chevron-left text-primary"></i>
        </a>
        <a class="btn  mb-3 carousel-btn anchor-tag" (click)="moveRight()"
          [ngClass]="{'pe-none opacity-25':clickRgtBtn==true}">
          <i class="fa fa-lg fa-chevron-right text-primary"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="container">
    <drag-scroll #nav (reachesLeftBound)="leftBoundStat($event)" scrollbar-hidden="true"
      (reachesRightBound)="reachesRightBound($event)">
      <!-- <div *ngFor="let port of item.ports,let i=index " drag-scroll-item class="drag-scroll-item-div">
        <app-custom-product-card [port]=port [productInfo]=item [index]=index [browseType]=browseType>
        </app-custom-product-card>
      </div> -->
      <div *ngFor="let port of item,let i=index " drag-scroll-item class="drag-scroll-item-div">
        <app-custom-product-card [port]=port [productInfo]=port [index]=index [browseType]=browseType>
               </app-custom-product-card> 
      </div>
    </drag-scroll>
  </div>
</div>
<div *ngIf="browseType=='port'">
  <div class="container">
    <div class="row carousel-width" *ngIf="item.products">
      <div class="col-12 col-sm-6 col-md-6 text-left">
        <span class="mb-3 ml-3 h2 bold d-flex align-items-center">{{item.name}}</span>
      </div>
      <div class="col-11 col-sm-6 col-md-6 text-right visible-xs" *ngIf="item.products.length>4">
        <a class="btn  mb-3 mr-1 carousel-btn anchor-tag" role="button" (click)="moveLeft()"
          [ngClass]="{'pe-none opacity-25':clickLftBtn==true}">
          <i class="fa fa-lg fa-chevron-left text-primary"></i>
        </a>
        <a class="btn  mb-3 carousel-btn anchor-tag" (click)="moveRight()"
          [ngClass]="{'pe-none opacity-25':clickRgtBtn==true}">
          <i class="fa fa-lg fa-chevron-right text-primary"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="container">
    <drag-scroll #nav (reachesLeftBound)="leftBoundStat($event)" scrollbar-hidden="true"
      (reachesRightBound)="reachesRightBound($event)">
      <div *ngFor="let product of item.products,let i=index " drag-scroll-item class="drag-scroll-item-div">
        <app-custom-product-card [port]=item [productInfo]=product [index]=index [browseType]=browseType>
        </app-custom-product-card>
      </div>
    </drag-scroll>
  </div>
</div>
